import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ExchangeRatesRepository } from '@core/repositories';
import { CurrencyPair, ExchangeRatesService } from '@api/exchange-rates';

@Injectable()
export class ExchangeRatesWebRepository extends ExchangeRatesRepository {

  private readonly exchangeRatesService = inject(ExchangeRatesService);

  public getCurrencyPairs(): Observable<CurrencyPair> {
    return this.exchangeRatesService.v1ExchangeRatesCurrencyPairsGet();
  }
}
